// extracted by mini-css-extract-plugin
module.exports = {"content":"SideBySide_content__GtXYJ","side":"SideBySide_side__Pb2Nr","contentMedia":"SideBySide_contentMedia__vp7Om"};